import { createSelector } from 'reselect';

import { stepperListener } from './stepper.listener';
import type { StepState, StepperState } from './stepper.types';
import { getStepState, isADesignStep } from './stepper.utils';

import { StepName } from '~/core/enums';
import type { RootState } from '~/redux/store';

export const selectCurrentStep = ({
  stepper,
}: RootState): StepperState['current'] => stepper.current;

export const selectStepState = createSelector(
  [
    ({ stepper }: RootState) => stepper.current,
    ({ stepper }: RootState) => stepper.steps,
    ({ visitedSteps }: RootState) => visitedSteps.visitedSteps,
  ],
  (currentStep, steps, visitedSteps) => {
    const lastVisitedStep = visitedSteps
      .toReversed()
      .find((step) => isADesignStep(step) && steps.includes(step));
    const fromStep =
      isADesignStep(currentStep) && lastVisitedStep
        ? lastVisitedStep
        : currentStep;
    const step: StepState = {
      current: currentStep,
      next: getStepState(fromStep, steps).next,
    };

    return step;
  }
);

export const selectEnabledSteps = ({
  stepper,
}: RootState): StepperState['enabledSteps'] => stepper.enabledSteps;

export const selectSteps = ({ stepper }: RootState): StepperState['steps'] =>
  stepper.steps;

export const checkEnabledStepsByListener = (steps: StepName[]) =>
  createSelector([(state: RootState) => state], (state) =>
    steps.map((step) => stepperListener[step].isStepEnabled(state))
  );
